<template>
  <div class="signin-problem">
    <h1>Sign-in could not be completed</h1>
    <p>
      We tried to sign you in several times and were turned away each time. This
      usually means the identity service is temporarily refusing requests.
    </p>
    <p class="hint">If it keeps happening, tell your administrator.</p>
    <button type="button" @click="retry">Try again</button>
  </div>
</template>

<script>
/**
 * The end of the sign-in circuit breaker.
 *
 * Without this the SPA would redirect to the identity provider, fail, and
 * redirect again — a loop that hammers the provider and shows the user nothing
 * but a flashing blank page. A rate-limited token endpoint produced exactly
 * that during testing.
 */
import oidc from '@/auth/oidcClient';
import { clearSignInAttempts } from '@/router/oidc-guard';

export default {
  name: 'SignInProblem',

  methods: {
    async retry() {
      clearSignInAttempts();
      oidc.clearSession();
      await oidc.beginLogin({ returnTo: '/welcome' });
    },
  },
};
</script>

<style scoped>
.signin-problem {
  min-height: 60vh;
  display: grid;
  place-content: center;
  justify-items: start;
  gap: 0.5rem;
  max-width: 46ch;
  margin: 0 auto;
  padding: 2rem;
}
h1 { font-size: 1.25rem; margin: 0; }
p { margin: 0; color: #5c6e6d; }
.hint { font-size: 0.9rem; }
button {
  margin-top: 1rem;
  padding: 0.55rem 1.25rem;
  cursor: pointer;
}
</style>
